import React from 'react';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Modal, ModalDialog, Typography, Button, Box } from '@mui/joy';

interface MissionSavedModalProps {
  open: boolean;
  onClose: () => void;
  missionName?: string;
}

const MissionSavedModal: React.FC<MissionSavedModalProps> = ({ open, onClose, missionName }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog
        variant='outlined'
        role='alertdialog'
        sx={{
          maxWidth: 400,
          borderRadius: 'md',
          p: 3,
          boxShadow: 'lg'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2
          }}
        >
          <CheckCircleIcon
            sx={{
              fontSize: 48,
              color: 'success.500'
            }}
          />
          <Typography level='title-lg' sx={{ textAlign: 'center' }}>
            Mission Saved Successfully!
          </Typography>
          {missionName && (
            <Typography level='body-md' sx={{ textAlign: 'center', color: 'neutral.600' }}>
              {missionName} has been saved to your missions.
            </Typography>
          )}
          <Button variant='solid' color='primary' onClick={onClose} sx={{ mt: 1, minWidth: 100 }}>
            OK
          </Button>
        </Box>
      </ModalDialog>
    </Modal>
  );
};

export default MissionSavedModal;
